import { render, staticRenderFns } from "./MailV2TemplateManager.vue?vue&type=template&id=3be0df7d&scoped=true"
import script from "./MailV2TemplateManager.vue?vue&type=script&lang=js"
export * from "./MailV2TemplateManager.vue?vue&type=script&lang=js"
import style0 from "./MailV2TemplateManager.vue?vue&type=style&index=0&id=3be0df7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0df7d",
  null
  
)

export default component.exports